import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pathway-of-toxicity.reducer';

export const PathwayOfToxicityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pathwayOfToxicityEntity = useAppSelector(state => state.pathwayOfToxicity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pathwayOfToxicityDetailsHeading">
          <Translate contentKey="coconApp.pathwayOfToxicity.detail.title">PathwayOfToxicity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{pathwayOfToxicityEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.pathwayOfToxicity.name">Name</Translate>
            </span>
          </dt>
          <dd>{pathwayOfToxicityEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/pathway-of-toxicity" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pathway-of-toxicity/${pathwayOfToxicityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PathwayOfToxicityDetail;
